import React from 'react';
import { useTranslation } from 'react-i18next';
import { Status, Select3, FieldLabel, highlightText } from '@weezevent/nacre';
import styles from './SelectInventories.module.css';

export default function SelectInventories({ onChange, multi = false, inventories, required = false, value }) {
    const { t } = useTranslation();

    const options = React.useMemo(
        () =>
            inventories?.map(inv => ({
                text: inv.name || inv.uuid,
                value: inv.uuid,
                active: inv.active
            })) || [],
        [inventories]
    );

    const selectedText =
        multi && Array.isArray(value) && value.length > 0
            ? t('ticket.partnersList.export_reservations_partner.n_events_selected', {
                  count: value.length
              })
            : null;

    return (
        <div className={styles.container}>
            <FieldLabel label={t('ticket.partnersList.export_reservations_partner.event_label')} required={required}>
                <Select3
                    multiple={multi}
                    options={options}
                    value={value || (multi ? [] : '')}
                    placeholder={t('ticket.partnersList.export_reservations_partner.select_event')}
                    onChange={onChange}
                    listItemsRenderer={inventoryItemRender}
                >
                    {selectedText}
                </Select3>
            </FieldLabel>
        </div>
    );
}

function inventoryItemRender(option, words) {
    // Careful, this is not a component, can't use hooks here
    return (
        <>
            <span>{highlightText(option.text || option.value, words)}</span>
            <StatusInventory active={option.active} />
        </>
    );
}

export const StatusInventory = React.memo(({ active }) => {
    const { t } = useTranslation();
    const color = active ? 'green' : 'grey';
    return <Status text={t(`attendees.filters.${active ? 'active' : 'inactive'}`)} color={color} />;
});
